.container {
  font-size: var(--rc-theme-font-size-text-sm);
}
